export enum ContentEditorDevices {
  DesktopFullWidth = 'desktop-full-width',
  Responsive = 'reponsive',
  Iphone14Pro = 'iphone-14-pro'
}
